export const PLACE_OF_SERVICE_OPTIONS = [
  { value: "office", label: "Office" },
  { value: "home", label: "Home" },
  { value: "birth-center", label: "Birth Center" },
  { value: "telehealth-client-home", label: "Telehealth – Client Home" },
  { value: "hospital", label: "Hospital" },
  { value: "other", label: "Other" },
] as const;

export type PlaceOfServiceValue = (typeof PLACE_OF_SERVICE_OPTIONS)[number]["value"];
